/**
 * The purpose of this file is to change events frames in order to get Sentry to link stack traces correctly with typescript source files.
 * It was created by following this guidance - https://docs.sentry.io/platforms/node/typescript/#changing-events-frames.
 * The value of `rootDir` set here is passed along to our Sentry JS SDK init call.
 */

export const rootDir = __dirname || process.cwd()
